import React, { useState, useEffect } from 'react';
import { apiGet } from '../lib/apiClient';

const EA_COLORS = ['#00ff88', '#a855f7', '#f59e0b', '#378ADD', '#ff4757', '#06b6d4', '#ec4899', '#14b8a6'];

export default function FloatingDDByEA({ accountId = 'all', typeFilter = 'all' }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    apiGet(`/api/floating-dd/summary?account_id=${accountId}${typeFilter !== 'all' ? `&type_filter=${typeFilter}` : ''}`)
      .then(setData)
      .catch(() => {});
  }, [accountId, typeFilter]);

  if (!data || data.length === 0) return (
    <div className="rounded-2xl p-5" style={{ background: 'var(--bg-card)', border: '1px solid var(--border-color)' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>📊 Floating DD Records by EA</h3>
      </div>
      <p className="text-sm text-center py-4" style={{ color: 'var(--text-dim)' }}>
        No per-EA floating DD records yet. Data will appear after the updated EA starts exporting.
      </p>
    </div>
  );

  return (
    <div className="rounded-2xl p-5" style={{ background: 'var(--bg-card)', border: '1px solid var(--border-color)' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium" style={{ color: 'var(--text-primary)' }}>📊 Floating DD Records by EA</h3>
        <span className="text-[11px]" style={{ color: 'var(--text-dim)' }}>Sorted by worst DD first</span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left border-b" style={{ color: 'var(--text-dim)', borderColor: 'var(--border-color)' }}>
              <th className="py-2 px-3 font-medium">EA Name</th>
              <th className="py-2 px-3 font-medium">Daily Record</th>
              <th className="py-2 px-3 font-medium">Weekly Record</th>
              <th className="py-2 px-3 font-medium">Monthly Record</th>
              <th className="py-2 px-3 font-medium">All-time Record</th>
              <th className="py-2 px-3 font-medium">Last Recorded</th>
            </tr>
          </thead>
          <tbody>
            {data.map((ea, i) => {
              const daily = ea.records?.daily;
              const weekly = ea.records?.weekly;
              const monthly = ea.records?.monthly;
              const allTime = ea.records?.all_time;

              const timestamps = [daily, weekly, monthly, allTime]
                .filter(Boolean)
                .map(r => r.recorded_at)
                .filter(Boolean);
              const lastRecorded = timestamps.length > 0
                ? timestamps.sort().reverse()[0]
                : null;

              return (
                <tr key={ea.magic} className="border-b transition-colors" style={{ borderColor: 'var(--border-color)' }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'var(--bg-card-hover)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}>
                  <td className="py-2.5 px-3">
                    <div className="flex items-center gap-2">
                      <span className="w-2 h-2 rounded-full" style={{ backgroundColor: EA_COLORS[i % EA_COLORS.length], boxShadow: `0 0 6px ${EA_COLORS[i % EA_COLORS.length]}` }} />
                      <span className="font-medium" style={{ color: 'var(--text-primary)' }}>{ea.ea_name}</span>
                      <span className="text-[10px]" style={{ color: 'var(--text-dim)' }}>#{ea.magic}</span>
                    </div>
                  </td>
                  <td className="py-2.5 px-3"><DDCell record={daily} /></td>
                  <td className="py-2.5 px-3"><DDCell record={weekly} /></td>
                  <td className="py-2.5 px-3"><DDCell record={monthly} /></td>
                  <td className="py-2.5 px-3"><DDCell record={allTime} /></td>
                  <td className="py-2.5 px-3 text-[10px]" style={{ color: 'var(--text-dim)' }}>
                    {lastRecorded ? new Date(lastRecorded).toLocaleDateString() : '—'}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function DDCell({ record }) {
  if (!record || !record.dd_amount) {
    return <span style={{ color: 'var(--text-dim)' }}>—</span>;
  }
  return (
    <div>
      <span className="font-semibold font-mono text-red-400">
        -${Math.abs(record.dd_amount).toFixed(2)}
      </span>
      <span className="text-[10px] ml-1" style={{ color: 'var(--text-dim)' }}>
        ({record.dd_percent?.toFixed(1)}%)
      </span>
    </div>
  );
}
